export default __webpack_public_path__ + "static/media/c5d0493dd3acfbb05337d3bb480166db.svg";